export const appendMomentScript = ($, script) => {
	$(script).appendTo(document.head);
};
